import { API_URL } from '../../../app-config/constants';
import type Badge from '../../../types/Badge';
import type BadgeDto from '../../../types/BadgeDto';
import { get, post, put, remove } from '../request';

const BADGES = 'badges';

getAll.operation = 'READ';
export function getAll() {
    return get<Badge[]>(`${API_URL}/${BADGES}`);
}

getPrototypes.operation = 'READ';
export function getPrototypes() {
    return get<Badge[]>(`${API_URL}/${BADGES}/prototypes`);
}

getIcons.operation = 'READ';
getIcons.idFrom = (icon: object | string) => (typeof icon === 'object' ? Object.values(icon).join('') : icon);
export function getIcons() {
    return get<string[]>(`${API_URL}/${BADGES}/icons`);
}

// Create returns list of badges!
create.invalidates = ['getAll', 'getPrototypes', 'getIcons'];
export function create(badge: BadgeDto) {
    return post<Badge[]>(`${API_URL}/${BADGES}`, { postData: badge });
}

// Update returns list of badges!
update.invalidates = ['getAll', 'getPrototypes', 'getIcons'];
export function update(badge: BadgeDto) {
    return put<Badge[]>(`${API_URL}/${BADGES}/${badge.id}`, { postData: badge });
}

order.operation = 'NO_OPERATION';
order.invalidates = ['getAll', 'getPrototypes'];
export function order(newOrder: string[]) {
    return post<Badge[]>(`${API_URL}/${BADGES}/order`, { postData: { order: newOrder } });
}

deleteBadge.operation = 'DELETE';
deleteBadge.invalidates = ['getAll', 'getPrototypes', 'getIcons'];
export function deleteBadge(id: string) {
    return remove(`${API_URL}/${BADGES}/${id}`);
}
